// extracted by css-extract-rspack-plugin
module.exports =  {"exitPollWidgetWrapper":"XREiO","noteText":"O9207","source":"Becxe"};